// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import connectActions from 'utils/connectActions'
import { withStyles } from '@material-ui/core/styles'

// Validation
import { Validator } from 'react-vld'

// Actions
import { logIn } from 'actions/me'

// Atoms
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import { LinkButton } from 'atoms/Link'
import CenteredCard from 'atoms/CenteredCard'
import { AppProgressActivator } from 'atoms/AppProgress'

// Icons
import { FacebookIcon, InstagramIcon } from 'atoms/Icons'

// Styles
const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
})

const mapActionsToProps = {
  logInAction: logIn
}

export default
@connectActions(mapActionsToProps)
@withStyles(styles)
@withRouter
class LoginForm extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    logInAction: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  getEmailValue = () => {
    return this.emailInput ? this.emailInput.state.value : ''
  }

  getPasswordValue = () => {
    return this.passwordInput ? this.passwordInput.state.value : ''
  }

  handleSubmit = formValidation => async (ev) => {
    ev.preventDefault()
    const { logInAction } = this.props
    const { isValid } = formValidation.validate()
    if (isValid && !logInAction.isPending) {
      const email = this.getEmailValue()
      const password = this.getPasswordValue()
      await logInAction.run({
        params: [email, password],
        updateComponentOnSuccess: false,
        silent: true,
      })
    }
  }

  emailRef = (input) => {
    this.emailInput = input
  }

  passwordRef = (input) => {
    this.passwordInput = input
  }

  handleForgotPasswordClick = () => {
    const { history } = this.props
    history.push({
      pathname: '/forgot-password',
      state: { email: this.getEmailValue() }
    })
  }

  renderInput(fieldName, props) {
    return (
      <TextInput required {...props} />
    )
  }

  renderForm() {
    const { classes, logInAction } = this.props
    return (
      <Validator>
        { formValidation => (
          <form onSubmit={this.handleSubmit(formValidation)}>
            <TextInput
              required
              email
              withBorder
              type="email"
              placeholder="email@example.com"
              label="Email address"
              innerRef={this.emailRef}
            />
            <Spacer />
            <TextInput
              required
              withBorder
              type="password"
              placeholder="******"
              label="Password"
              innerRef={this.passwordRef}
            />

            { logInAction.isPending && (
              <AppProgressActivator />
            ) }

            { logInAction.isFailed && (
              <Fragment>
                <Spacer />
                <Typography color="error">
                  { logInAction.error.message }
                </Typography>
              </Fragment>
            ) }

            <Spacer />
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              type="submit"
              style={{ boxShadow: 'none' }}
            >
              Sign in
            </Button>

            <Spacer />
            <Button fullWidth href="/api/v1/social/facebook">
              <FacebookIcon className={classes.icon} />
              Sign in with Facebook
            </Button>
            <Button fullWidth href="/api/v1/social/instagram">
              <InstagramIcon className={classes.icon} />
              Sign in with Instagram
            </Button>
          </form>
        ) }
      </Validator>
    )
  }

  render() {
    return (
      <CenteredCard>
        <CardHeader title="Sign in" />
        <CardContent>
          { this.renderForm() }
        </CardContent>
        <Divider />
        <CardActions>
          <Grid container justify="space-between">
            <Grid item>
              <Button size="small" color="secondary" onClick={this.handleForgotPasswordClick}>
                Forgot password?
              </Button>
            </Grid>
            <Grid item>
              <LinkButton color="secondary" to="/signup" size="small">
                Sign up
              </LinkButton>
            </Grid>
          </Grid>
        </CardActions>
      </CenteredCard>
    )
  }
}
